module.exports = __webpack_public_path__ + "media/site/images/products/ekanban-screen2-917484324d927355cc3aaeb878af2c42.png";